import { ServiceBase, Result } from "./ServiceBase";
import { ImpactPartner } from "../models/ImpactPartner";
import { PartnerMessage } from "../models/PartnerMessage";

export default class ImpactPartnerService extends ServiceBase {

    public static async list(): Promise<Result<ImpactPartner[]>> {

        var result = await this.requestNotAuthJson<ImpactPartner[]>({
            url: `/api/ImpactPartner/list/`,
            method: "GET"            
        });

        return result;
    }

    public static async loginList(): Promise<Result<ImpactPartner[]>> {

        var result = await this.requestNotAuthJson<ImpactPartner[]>({
            url: `/api/ImpactPartner/loginList/`,
            method: "GET"
        });

        return result;
    }

    public static async get(id: string): Promise<Result<ImpactPartner>> {

        var result = await this.requestNotAuthJson<ImpactPartner>({
            url: `/api/ImpactPartner/get/${id}`,
            method: "GET"
        });

        return result;
    }

    public static async getPartnersMessages(): Promise<Result<PartnerMessage[]>> {

        var result = await this.requestNotAuthJson<PartnerMessage[]>({
            url: `/api/ImpactPartner/messages/`,
            method: "GET"
        });

        return result;
    }
}
